export interface CityConfig {
	_id: string;
	names: string[];
	state?: string;
	bounds: {
		north: number;
		south: number;
		east: number;
		west: number;
	};
}

export const cities: CityConfig[] = [
	{
		_id: "bengaluru",
		names: ["Bengaluru", "Bangalore"],
		bounds: {
			north: 13.471908,
			south: 12.70449,
			east: 78.046592,
			west: 77.318748,
		},
	},
];
